module.exports = __webpack_public_path__ + "static/media/leiras.c4fbb41b.png";